import { useEffect, useState } from 'react';
import Seo from '@/components/feature/Seo';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import {
  CategoryGrid,
  LatestSection,
  RankingSection,
  FeaturedSection,
  AboutStrip,
  FaqTeaser,
  CtaBanner,
} from './components/Sections';
import { comics } from '@/mocks/comics';

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <Seo
        title="韩国漫画网 - 爱情漫画、奇幻漫画、动作漫画在线畅读 | 韩漫星球"
        description="韩漫星球是专业的韩国漫画网，汇聚爱情、奇幻、动作、校园、悬疑等全部分类的海量漫画，高清画质、每日更新，帮你快速找到想看的每一部佳作。"
        keywords="韩国漫画网,漫画分类,爱情漫画,奇幻漫画,动作漫画,校园漫画,悬疑漫画,漫画大全"
        canonicalPath="/"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '韩漫星球',
            alternateName: '韩国漫画网',
            url: typeof window !== 'undefined' ? window.location.origin : '/',
            description: '汇聚爱情、奇幻、动作、校园、悬疑等全部分类的海量韩国漫画。',
            inLanguage: 'zh-CN',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩漫星球',
            url: typeof window !== 'undefined' ? window.location.origin : '/',
            logo: typeof window !== 'undefined' ? `${window.location.origin}/favicon.svg` : '/favicon.svg',
          },
        ]}
      />

      <Navbar overHero />

      <main>
        <Hero />

        <CategoryGrid />

        <LatestSection />

        <RankingSection />

        <FeaturedSection />

        <AboutStrip />

        <CtaBanner comic={comics[2]} />

        <FaqTeaser />
      </main>

      <Footer />

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </>
  );
}